import React, { Fragment, useEffect, useState } from "react";
import { httpClient } from "../../dataProvider";
import { apiUrl1 } from "../../utilities/type";
import { useCallback } from "react";
import { Box } from "@material-ui/core";
import SimpleCard from "./SimpleCard";

const Dashboard = (props: any) => {

    const url = `${apiUrl1}/homes`;
    const [collections, setCollections] = useState<[]>([]);

    const fetchCollections = useCallback(async () => {
        try{
            const { json } = await httpClient(url);
    
            setCollections(json.data.collections);
        } catch (err) {

        }

    },[httpClient])

    useEffect(() => {
        fetchCollections();
    },[])

    return(
        <Fragment>
            {
                collections.map((data:any, index:number) => {
                    const { id, title = "No title", values } = data;
                    return <Box key={index} m={1} style={{display: 'flex'}}>
                        {
                            values.map((val: any, idx: number) => {
                                return <SimpleCard key={idx} {...val} />
                            })
                        }
                    </Box>
                })
            }
        </Fragment>
    )
}

export default Dashboard;